// 招商审核
import store from '@/store';
export const option = {
  height: 'auto',
  calcHeight: 80,
  tip: false,
  delBtn: false,
  editBtn: false,
  addBtnText: '新增招商码',
  addTitle: '新增招商码',
  addBtn: false,
  searchShow: true,
  searchMenuSpan: 6,
  searchSpan:6,
  searchLabelWidth: 100,
  border: true,
  index: false,
  menu: true,
  indexLabel: '序号',
  selection: false,
  viewBtn: false,
  dialogType: 'dialog',
  dialogClickModal: false,
  column: [
    {
      label: '代理商简称',
      prop: 'agentShortName',
      type: 'input',
      search:true,
      searchOrder: 1000,
      minWidth:120,
    },
    {
      label: '开通产品',
      prop: 'rentType',
      type: 'select',
      display:false,
      search:true,
      searchOrder: 998,
      dicData: store.getters.porductTypes,
    },
    {
      label: '新增地区',
      prop: 'cityOpened',
      type: 'input',
      display:false
    },
    {
      label: '招商经理',
      prop: 'managerName',
      type: 'input',
      display:false
    },
    {
      label: '兜底比例',
      prop: 'bottomLineRatio',
      type: 'input',
      display:false,
      formatter: (row, value) => {
        if (row.rentType == 10) return '/'
        return value ? `${value}%` : '/'
      }
    },
    {
      label: '杠杆比例',
      prop: 'leverageRatio',
      type: 'input',
      display:false,
      formatter: (row, value) => {
        if (row.rentType == 10) return '/'
        return value ? `1:${value}` : '/'
      }
    },
    {
      label: '签约公司',
      prop: 'agentFullName',
      type: 'input',
      display:false
    },
    {
      label: '签约日期',
      prop: 'createTime',
      type: 'input',
      display:false,
      formatter: (row, value) => {
        return value ?? '/'
      }
    },
    {
      label: '加盟费',
      prop: 'franchiseFee',
      type: 'input',
      display:false,
      formatter: (row, value) => {
        return value ?? '/'
      }
    },
    {
      label: '保证金',
      prop: 'deposit',
      type: 'input',
      display:false,
      formatter: (row, value) => {
        return value ?? '/'
      }
    },
    {
      label: '招商经理',
      prop: 'managerCode',
      type: 'select',
      searchOrder: 997,
      search:true,
      hide: true,
      dicUrl: '/api/blade-loanManagerCodeInfo/loanManagerCodeInfo/dropDown',
      props: {
        label: 'managerName',
        value: 'managerCode'
      }
    },

  ],
};
